import React from 'react';
import { StaticContext } from 'react-router';
import { 
    Route as ReactRoute, 
    Redirect, 
    RouteComponentProps, 
    RouteProps 
} from 'react-router-dom';

interface AdminRouteProps extends RouteProps
{
    isAdmin?          : boolean;
    layout?          : React.ComponentType;
    component?       : React.ComponentType;
    publicComponent? : React.ComponentType;
}

type RenderProps = RouteComponentProps<{ [x: string]: string | undefined; }, StaticContext, unknown>;

export const AdminRoute : React.FunctionComponent<AdminRouteProps> = ({ 
    isAdmin, 
    layout : Layout, 
    component : Component = () => (<></>), 
    publicComponent : PublicComponent,
    ...rest 
}) =>
{
    const render = (props : RenderProps) =>
        (
            isAdmin ? (
                Layout === undefined ? (
                    <Component {...props} {...rest} />
                ) : (
                    <Layout>
                        <Component {...props} {...rest} />
                    </Layout>
                )
            ) : (
                PublicComponent === undefined ? (
                    <Redirect to="/" />
                ) : (
                    Layout === undefined ? (
                        <PublicComponent {...props} {...rest} />
                    ) : (
                        <Layout>
                            <PublicComponent {...props} {...rest} />
                        </Layout>
                    )
                )
            )
        );

    return <ReactRoute render={render} />;
};